import React, { useEffect, useMemo, useReducer, Fragment, useCallback, useContext } from "react";
import Services from "../../Services/dataService";
import { GoogleMap, Functions, fetchData, Legends, Constant, Components, MapButtons, DownloadShops } from "../Common";
import { selectedPolygonTypes } from "../Common/Constants";
import Config from "../Common/Config";
import Filters from "./Filters";
import { Select, Button, Radio, notification, Row } from "antd";
import pick from "lodash/pick";
import isEmpty from "lodash/isEmpty";
import flattenDeep from "lodash/flatMapDeep";
import has from "lodash/has";
import Stats from "./Stats";
import sample from "lodash/sample";
import { Container as ReactContainer, Row as ReactRow, Col as ReactCol, Card as ReactCard } from "reactstrap";
import { cloneDeep, fromPairs, merge, pull, set } from "lodash";
import Initial from "./Initail";
import { HomeContext, UploadContext } from "../Context";
import { dropdownHierarchyType, formateString } from "../Common/Functions";
import PolygonLayers from "./PolygonLayers";
import { DownloadMarkersButtonLayer } from "./DownloadMarkersButtonLayer";
import OutletsSteps from "./UploadOutlet/Steps";
import Modals from "./UploadOutlet/Modal";
import userServices from "../../UserServices/UserServices";
import DownloadRouteData from "./DownloadMarkersButtonLayer/DownloadRouteData";
import PolygonModal from "../PolygonsModal";
import HandleMarkerClick from "./Markers/HandleMarkerClick";
import TenantSecDefinition from "./TenantSecDefinition";
import { havePermission } from "../../permissions";
import MARKER_PERMISSIONS from "../../permissions/Markers.json";
import SelectedPolygonShopList from "./SelectedPolygonShopList";
import { MainNavbar } from "../Core";
import { useParams } from "react-router-dom";

const screenRatio = 1.7778;
const heightFactor1 = 0.6; //0.59;
const mapHeight = Math.floor((window.innerWidth / screenRatio) * heightFactor1);
const { getUserPolygons } = fetchData;
const {
	Info,
	FindCenter,
	getBooleanVale,
	getTenantName,
	getLegend,
	modifyFilterObjectForQuery,
	Error,
	getSelectedPolygons
} = Functions;
const {
	HomeActions: Actions,
	overLapPolygons,
	getselectedTypeIds,
	getClientandTenantFilter,
	filterPolygon,
	variables,
	polygonStartString,
	defaultFilters
} = Constant;

const { getCountTable } = Components;
const { clientShops, censusShops, filteredShops, bat_contracted_outlets_selected, bat_contracted_outlets } = variables;
const { allClientMarkersVisibility } = Config;
const { filterPolygons, swtichPolygons } = Actions;
const {
	populationDensity,
	defaultpolygons,
	CELLSITES,
	PopulationGrids,
	DailyTrafficData,
	digitalPersona,
	TargetedConsumer,
	motor_spots,
	sec_density,
	SecPolgons,
	whiteSpace_density,
	demographicPopulationDensity,
	social_media_behaviors,
	smoking_zones
} = selectedPolygonTypes;
const _initialState = {
	previousSelectedFilters: {},
	CellSiteIds: [],
	cellSiteFilteredShops: [],
	apiTracking: {},
	areasMapping: new Map(),
	tableData: {},
	dropdownData: [],
	selecteddropDown: [],
	dropdownDataCopy: [],
	dropdownMapping: [],
	ApplyFilterLoading: {},
	keyNameMapping: {},
	selectedStructure: {},
	availableStructure: {},
	allPolygons: {},
	shopsStructure: new Map(),
	shopCounts: {},
	center: [],
	selectedType: "",
	slider: null,
	legends: [],
	raw_markers: {},
	breakClusters: false,
	filterSecPolygon: [],
	allSliders: {},
	allLegends: {},
	routesData: {},
	_markers: {},
	tenant_markers: {},
	tenant_markers_1: {},
	raw_tenant_markers: {},
	raw_tenant_markers_1: {},
	all_raw_tenant_markers: {},
	selectedPolygons: defaultpolygons,
	modelVisible: false,
	loadingsData: {},
	selectedData: {},
	sliderValue: {},
	clientFilter: null,
	censusFilter: null,
	censusFilterKey: null,
	polygonModal: false,
	selectedPolygon: null,
	markerDetailVisible: false,
	selectedMarker: null,
	defaultSliderValues: {},
	demographicFilterKeys: [],
	SocialMediaBehaviorsKeys: [],
	selectedPolygonShopListVisible: false
};
const reducer = (state, action) => {
	switch (action.type) {
		case "setObject":
			const { actions } = action;
			Object.entries(actions).forEach(([type, value]) => {
				const service = {
					set: data => Object.entries(data).forEach(([key, value]) => set(state, key, value)),
					merge: data => Object.entries(data).forEach(([key, value]) => merge(state, { [key]: value })),
					dynamic: data => Object.entries(data).forEach(([key, value]) => set(state, key, state[value]))
				};
				service[type](value);
			});
			return { ...state };
		// case swtichPolygons:
		// 	const { polygons: selectedPolygonType } = action;
		// 	const {
		// 		allPolygons: polygons,
		// 		selectedPolygons: previousSelectedPolygonType,
		// 		allLegends: legends,
		// 		keyNameMapping,
		// 		dropdownMapping: mapping,
		// 		selectedType,
		// 		allSliders: sliders,
		// 		selecteddropDown: selected
		// 	} = state;
		// 	const currentSelectedTypeIndex = mapping?.indexOf(selectedType);

		// 	if (polygons[selectedPolygonType]) {
		// 		let { updatedpolygons, updatedlegends, updatedselectedType, updatedSlider } = switchPolygons({
		// 			previousSelectedPolygonType,
		// 			selectedPolygonType,
		// 			polygons,
		// 			legends,
		// 			selectedGeo: selected[currentSelectedTypeIndex],
		// 			sliders,
		// 			keyNameMapping
		// 		});

		// 		if (selectedPolygonType === CELLSITES) {
		// 			let CellSiteIds = Object.entries(updatedpolygons)
		// 				.filter(([, { _id }]) => !!_id)
		// 				.map(([, { _id }]) => _id);
		// 			return {
		// 				...state,
		// 				CellSiteIds,
		// 				selectedPolygons: updatedselectedType,
		// 				_polygons: updatedpolygons,
		// 				legends: updatedlegends,
		// 				slider: updatedSlider
		// 			};
		// 		} else {
		// 			// const sliderData = sliders[selectedPolygonType] || [];

		// 			return {
		// 				...state,
		// 				selectedPolygons: updatedselectedType,
		// 				_polygons: updatedpolygons,
		// 				legends: updatedlegends,
		// 				slider: updatedSlider
		// 				// sliderValue: {
		// 				// 	[selectedPolygonType]: [sliderData.min || 0, sliderData.max || 100]
		// 				// }
		// 			};
		// 		}
		// 	} else {
		// 		Info(`Generating ${selectedPolygonType} Polygons. Try Again ..`);
		// 		return state;
		// 	}

		case swtichPolygons: {
			const { polygons: selectedPolygonType } = action;
			const {
				allPolygons,
				selectedPolygons: previousSelectedPolygonType,
				allLegends: legends,
				keyNameMapping,
				dropdownMapping,
				selectedType,
				allSliders: sliders,
				selecteddropDown: selected,
				sliderValue: currentSliderValues,
				defaultSliderValues
			} = state;

			const currentSelectedTypeIndex = dropdownMapping.indexOf(selectedType);

			// Make sure the requested polygon type exists; if not, inform the user and exit
			if (!allPolygons[selectedPolygonType]) {
				Info(`Generating ${selectedPolygonType} Polygons. Try Again ..`);
				return state;
			}

			// Call the switchPolygons helper to get updated state values
			const { updatedpolygons, updatedlegends, updatedselectedType, updatedSlider } = switchPolygons({
				previousSelectedPolygonType,
				selectedPolygonType,
				polygons: allPolygons,
				legends,
				selectedGeo: selected[currentSelectedTypeIndex],
				sliders,
				keyNameMapping,
				currentSliderValues,
				defaultSliderValues
			});

			// Build a new state object with the updated values
			const newState = {
				...state,
				selectedPolygons: updatedselectedType,
				_polygons: updatedpolygons,
				legends: updatedlegends,
				slider: updatedSlider
			};

			// If the type is CELLSITES, extract the CellSiteIds from the updated polygons
			if (selectedPolygonType === CELLSITES) {
				const CellSiteIds = Object.values(updatedpolygons)
					.filter(polygon => !!polygon._id)
					.map(polygon => polygon._id);
				return { ...newState, CellSiteIds };
			}
			return newState;
		}

		case filterPolygons: {
			const {
				allPolygons,
				selecteddropDown,
				dropdownMapping,
				selectedType,
				selectedPolygons,
				_polygons,
				shopsStructure,
				tableData,
				sliderValue,
				shopCounts
			} = state;

			// Determine the selected geographic IDs based on the dropdown mapping
			const selectedIndex = dropdownMapping.indexOf(selectedType);
			const selectedIds = selecteddropDown[selectedIndex] || selecteddropDown[selecteddropDown.length - 1] || [];

			// Extract type and value from the action. Preserve the original type in "typeOnly"
			const { type: rawType, value } = action.value;
			const typeOnly = rawType;
			const type = rawType.split("-")[0];

			// Exit early if there is no filterPolygon function for this type
			if (!has(filterPolygon, typeOnly)) return state;

			// Check if the polygon data exists for the selected area
			if (!allPolygons?.[type]?.[selectedIds[0]]) {
				notification.warning({
					message: "Warning",
					description: `No ${type} Data Available for Selected Area.`
				});
				return {
					...state,
					sliderValue: { ...sliderValue, [typeOnly]: value }
				};
			}

			const previousSliderValues = cloneDeep(sliderValue);
			// Always create a new sliderValue object to preserve immutability
			const newSliderValue = { ...sliderValue, [typeOnly]: value };

			const previousFilter = previousSliderValues?.[typeOnly];

			if (previousFilter === value) {
				newSliderValue[typeOnly] = undefined;
			}

			// Filter the polygons using the appropriate filter function
			let newPoly = filterPolygon[typeOnly]({
				sliderValue: newSliderValue,
				filter: value,
				polygons: Object.values(allPolygons[type][selectedIds[0]]),
				previousSliderValues
			});

			// Check if there is an overlap-handling function for the current selection
			const overlapKey = `${type}-${selectedPolygons}`;
			if (overLapPolygons[overlapKey]) {
				// Build an object keyed by index
				const polygonObject = newPoly.reduce((acc, poly, index) => {
					acc[`${type}-${index}`] = poly;
					return acc;
				}, {});

				const { newPolygons, totalShops, CellSiteIds, totalShopsCount } = overLapPolygons[overlapKey]({
					polygons: allPolygons,
					updatedpolygons: polygonObject,
					selectedGeo: selectedIds,
					_polygons,
					shopsStructure,
					sliderValue: newSliderValue,
					shopCounts
				});
				newPoly = newPolygons;

				// If we have data on shops or cell site IDs, update those too
				if (totalShops || CellSiteIds) {
					return {
						...state,
						CellSiteIds,
						_polygons: newPoly,
						tableData: { ...tableData, [filteredShops]: totalShopsCount },
						cellSiteFilteredShops: totalShops || [],
						sliderValue: newSliderValue
					};
				}
				return { ...state, _polygons: newPoly, sliderValue: newSliderValue };
			}

			// Default update: update the slider, selected polygon type, and the polygon data
			return {
				...state,
				sliderValue: newSliderValue,
				selectedPolygons: type,
				_polygons: newPoly
			};
		}

		case "filterMarkers": {
			const { sourceKey, setTo, filterKey, filtervalue, operator } = action.value;
			let markers = cloneDeep(state[sourceKey] || {});
			if (!isEmpty(markers)) {
				switch (operator) {
					case "===":
						markers = fromPairs(
							Object.entries(markers).filter(([, value]) => {
								const { filterData } = value;
								if (!isEmpty(filterData)) {
									if (has(filterData, filterKey)) {
										return filterData[filterKey] === filtervalue;
									}
								}
								return false;
							})
						);
						break;
					case "!==":
						markers = fromPairs(
							Object.entries(markers).filter(([, value]) => {
								const { filterData } = value;
								if (!isEmpty(filterData)) {
									if (has(filterData, filterKey)) {
										return filterData[filterKey] !== filtervalue;
									}
								}
								return false;
							})
						);
						break;
					default:
						break;
				}
				return {
					...state,
					[setTo]: markers
				};
			} else return state;
		}
		case "SetArray":
			const { index, value, key } = action.value;

			let { [key]: array } = state;
			array && array.fill([], index);
			if (index === 0) array = [value];
			else array[index] = value;
			return { ...state, [key]: array };
		case "MergeMaps":
			const { [action.key]: map1 } = state;
			const map2 = action.value;
			let mergedMap = new Map(
				[...map1, ...map2].map(([k]) => [
					k,
					Array.from(new Set([...(map1.get(k) || []), ...(map2.get(k) || [])]))
				])
			);
			return {
				...state,
				[action.key]: mergedMap
			};
		case "UPDATETABLEDATA":
			const {
				allPolygons: { ShowStatsData },
				selecteddropDown,
				tableData,
				dropdownMapping,
				raw_tenant_markers,
				raw_tenant_markers_1,

				shopCounts,
				raw_markers,
				selectedType: type,
				shopsStructure,
				selectedPolygons,
				CellSiteIds,
				tenant
			} = state;

			const selectedIndex = dropdownMapping.indexOf(type);

			const selectedIds = selecteddropDown[selectedIndex] || selecteddropDown[selecteddropDown.length - 1] || [];
			let newTableData = {};
			let tenant_markers = {};
			let tenant_markers_1 = {};

			let _markers = {};
			if (selectedIds) {
				const data = pick(ShowStatsData, selectedIds);
				if (!isEmpty(data)) {
					function isFloat(n) {
						return Number(n) === n && n % 1 !== 0;
					}
					newTableData = Object.values(data).reduce((a, b) => {
						for (let [key, value] of Object.entries(b)) {
							if (!["coordinates"].includes(key)) {
								if (Array.isArray(value)) {
									a[key] = (a?.[key] || 0) + value.length;
								} else if (typeof value === "number") {
									if (isFloat(value)) {
										a[key] = Number(Number((a?.[key] || 0) + value).toFixed(2));
									} else a[key] = (a?.[key] || 0) + value;
								} else if (typeof value === "object" && !Array.isArray(value)) {
									for (let [k1, v1] of Object.entries(value)) {
										if (!has(a, `${key}.${k1}`)) {
											a[key] = { ...(a[key] || {}), [k1]: v1 };
										} else {
											a[key] = { ...a[key], [k1]: a[key][k1] + v1 };
										}
									}
								}
							}
						}
						return a;
					}, {});
				}
				if (!isEmpty(shopCounts)) {
					let data = selectedIds.map(elm => shopCounts[elm] || 0);

					if (!isEmpty(data)) {
						let totalCensusShopsCount = Object.values(data).reduce((a, b) => a + b, 0);
						if (tableData[censusShops] !== "LOADING") newTableData[censusShops] = totalCensusShopsCount;
					}

					// data = pick(
					// 	shopCounts,
					// 	selectedIds.map(key => `${key}-Client`)
					// );

					data = selectedIds.map(key => `${key}-Client`).map(elm => shopCounts[elm] || 0);
					if (!isEmpty(data)) {
						let totalClientShopsCount = Object.values(data).reduce((a, b) => a + b, 0);
						if (tableData[clientShops] !== "LOADING") newTableData[clientShops] = totalClientShopsCount;
					}

					data = selectedIds.map(key => `${key}-${bat_contracted_outlets}`).map(elm => shopCounts[elm] || 0);
					if (!isEmpty(data)) {
						let totalClientShopsCount = Object.values(data).reduce((a, b) => a + b, 0);
						newTableData[bat_contracted_outlets] = totalClientShopsCount;
					}
				}

				if (!isEmpty(raw_tenant_markers)) {
					let selected = [];
					let forClient = selectedIds.map(key => `${key}-Client`);
					for (let id of forClient) {
						if (shopsStructure.has(id)) {
							let ids = shopsStructure.get(id);
							selected = [...selected, ...ids];
						}
					}
					tenant_markers = pick(raw_tenant_markers, flattenDeep(selected));
				}
				if (!isEmpty(raw_tenant_markers_1)) {
					let selected = [];
					let forClient = selectedIds.map(key => `${key}-${bat_contracted_outlets}`);
					for (let id of forClient) {
						if (shopsStructure.has(id)) {
							let ids = shopsStructure.get(id);
							selected = [...selected, ...ids];
						}
					}
					tenant_markers_1 = pick(raw_tenant_markers_1, flattenDeep(selected));
				}
				if (!isEmpty(raw_markers)) {
					let selectedTypeIds = selectedIds;
					if (selectedPolygons === CELLSITES) {
						selectedTypeIds = CellSiteIds;
					}
					let selected = [];
					for (let id of selectedTypeIds) {
						if (shopsStructure.has(id)) {
							let ids = shopsStructure.get(id);
							selected = [...selected, ...ids];
						}
					}
					_markers = pick(raw_markers, flattenDeep(selected));
				}

				let Key = `${getTenantName(tenant)} Selected`;
				newTableData = { ...newTableData, [Key]: 0 };
			}

			return {
				...state,
				tableData: { ...tableData, ...newTableData, polygons: selectedIds?.length || 0 },
				tenant_markers,
				tenant_markers_1,
				_markers
			};
		case "RESET": {
			const {
				selecteddropDown,
				dropdownMapping,
				raw_tenant_markers_1,

				raw_tenant_markers,
				raw_markers,
				selectedType: type,
				shopsStructure,
				selectedPolygons,
				CellSiteIds
			} = state;
			let tenant_markers = [];
			let tenant_markers_1 = [];
			let _markers = [];
			const selectedIndex = dropdownMapping.indexOf(type);

			const selectedIds = selecteddropDown[selectedIndex] || selecteddropDown[selecteddropDown.length - 1] || [];

			if (!isEmpty(raw_tenant_markers)) {
				let selected = [];
				let forClient = selectedIds.map(key => `${key}-Client`);
				for (let id of forClient) {
					if (shopsStructure.has(id)) {
						let ids = shopsStructure.get(id);
						selected = [...selected, ...ids];
					}
				}
				tenant_markers = pick(raw_tenant_markers, flattenDeep(selected));
			}
			if (!isEmpty(raw_tenant_markers_1)) {
				let selected = [];
				let forClient = selectedIds.map(key => `${key}-${bat_contracted_outlets}`);
				for (let id of forClient) {
					if (shopsStructure.has(id)) {
						let ids = shopsStructure.get(id);
						selected = [...selected, ...ids];
					}
				}
				tenant_markers_1 = pick(raw_tenant_markers_1, flattenDeep(selected));
			}

			if (!isEmpty(raw_markers)) {
				let selectedTypeIds = selectedIds;
				if (selectedPolygons === CELLSITES) {
					selectedTypeIds = CellSiteIds;
				}
				let selected = [];
				for (let id of selectedTypeIds) {
					if (shopsStructure.has(id)) {
						let ids = shopsStructure.get(id);
						selected = [...selected, ...ids];
					}
				}
				_markers = pick(raw_markers, flattenDeep(selected));
			}

			return {
				...state,
				tenant_markers,
				tenant_markers_1,
				_markers
			};
		}
		case "FilterPolygons": {
			const { _polygons: previousPolygon, allPolygons: polygonsSec, previousSelectedFilters } = state;
			const { key: filterKey, geo, selectedPolygonType } = action.value;
			const previousSelectedFilter = previousSelectedFilters[selectedPolygonType] || null;
			const filteredPolygons = {};
			const selectedPolygons = polygonsSec[selectedPolygonType][geo];

			Object.entries(previousPolygon).forEach(([key, value]) => {
				if (!value.id.startsWith(polygonStartString[selectedPolygonType])) {
					filteredPolygons[key] = value;
				}
			});

			Object.entries(selectedPolygons).forEach(([key, value]) => {
				const {
					filterData: { value: FilterValue }
				} = value;

				if (previousSelectedFilter === filterKey) {
					filteredPolygons[key] = value;
				} else if (FilterValue === filterKey) {
					filteredPolygons[key] = value;
				}
			});

			return {
				...state,
				previousSelectedFilters: {
					...previousSelectedFilters,
					[selectedPolygonType]: previousSelectedFilter === filterKey ? null : filterKey
				},
				_polygons: filteredPolygons
			};
		}

		case "FilterClientShops":
			const {
				raw_tenant_markers: currentMarkers,
				selecteddropDown: selecteddropDown1,
				dropdownMapping: dropdownMapping1,
				selectedType: type1,
				shopsStructure: shopsStructure1,
				clientFilter
			} = state;
			const { key: filterKey, text: filterText } = action.value;
			let new_Tenant_Markers = {};
			let new_Tenant_Markers_1 = {};

			const selectedIndex1 = dropdownMapping1.indexOf(type1);

			const selectedIds1 =
				selecteddropDown1[selectedIndex1] || selecteddropDown1[selecteddropDown1.length - 1] || [];
			let selectedPolygon = [];
			let forClient = selectedIds1.map(key => `${key}-Client`);
			for (let id of forClient) {
				if (shopsStructure1.has(id)) {
					let ids = shopsStructure1.get(id);
					selectedPolygon = [...selectedPolygon, ...ids];
				}
			}
			new_Tenant_Markers = pick(currentMarkers, flattenDeep(selectedPolygon));

			forClient = selectedIds1.map(key => `${key}-${bat_contracted_outlets}`);
			for (let id of forClient) {
				if (shopsStructure1.has(id)) {
					let ids = shopsStructure1.get(id);
					selectedPolygon = [...selectedPolygon, ...ids];
				}
			}
			new_Tenant_Markers_1 = pick(currentMarkers, flattenDeep(selectedPolygon));
			if (clientFilter === filterText) {
				return {
					...state,
					clientFilter: null,
					tenant_markers: new_Tenant_Markers,
					tenant_markers_1: new_Tenant_Markers_1
				};
			}

			if (!isEmpty(currentMarkers)) {
				let filtered = Object.entries(new_Tenant_Markers).filter(([, value]) => {
					if (value?.data) {
						return value.data[filterKey] === filterText;
					}
					return false;
				});

				new_Tenant_Markers = fromPairs(filtered);
				new_Tenant_Markers_1 = fromPairs(filtered);
			}

			return {
				...state,
				clientFilter: filterText,
				tenant_markers: new_Tenant_Markers,
				tenant_markers_1: new_Tenant_Markers_1
			};
		case "FilterCensusShops":
			const {
				raw_markers: currentCensusMarkers,
				selecteddropDown: selecteddropDown2,
				dropdownMapping: dropdownMapping2,
				selectedType: type2,
				shopsStructure: shopsStructure2,
				censusFilter,
				censusFilterKey
			} = state;
			// eslint-disable-next-line no-unused-vars
			const { key: filterKey1, text: filterText1, color: newCensusColor } = action.value;
			let new_Census_Markers = {};

			const selectedIndex2 = dropdownMapping2.indexOf(type2);

			const selectedIds2 =
				selecteddropDown2[selectedIndex2] || selecteddropDown2[selecteddropDown2.length - 1] || [];
			let selectedPolygon1 = [];
			let forCensus = selectedIds2.map(key => `${key}`);
			for (let id of forCensus) {
				if (shopsStructure2.has(id)) {
					let ids = shopsStructure2.get(id);
					selectedPolygon1 = [...selectedPolygon1, ...ids];
				}
			}
			new_Census_Markers = pick(currentCensusMarkers, flattenDeep(selectedPolygon1));

			if (censusFilter === filterText1 && censusFilterKey === filterKey1) {
				return {
					...state,
					censusFilter: null,
					censusFilterKey: null,
					_markers: new_Census_Markers
				};
			}

			if (!isEmpty(currentCensusMarkers)) {
				let filtered = Object.entries(new_Census_Markers)
					.filter(([, value]) => {
						if (value?.data) {
							return value.data[filterKey1] === filterText1;
						}
						return false;
					})
					.map(([key, value]) => {
						// If a new color is provided, update the marker's color
						if (newCensusColor) {
							value.color = newCensusColor;
						}
						return [key, value];
					});

				new_Census_Markers = fromPairs(filtered);
			}

			return {
				...state,
				censusFilter: filterText1,
				censusFilterKey: filterKey1,
				_markers: new_Census_Markers
			};

		case "resetAll":
			return _initialState;
		case "RESETALLSLIDERS":
			const { defaultSliderValues } = state;

			// let newSliderValue = {};
			// Object.entries(sliders).forEach(([, value]) => {
			// 	if (value) {
			// 		if (Array.isArray(value)) {
			// 			value.forEach(val => {
			// 				const { type, min, max } = val;
			// 				newSliderValue[type] = [min || 0, max || 100];
			// 			});
			// 		} else {
			// 			const { type, min, max } = value;
			// 			newSliderValue[type] = [min || 0, max || 100];
			// 		}
			// 	}
			// });

			return { ...state, sliderValue: defaultSliderValues };
		default:
			return state;
	}
};

const switchPolygons = ({
	previousSelectedPolygonType,
	selectedPolygonType,
	polygons,
	legends,
	selectedGeo,
	sliders,
	currentSliderValues,
	defaultSliderValues
}) => {
	let updatedpolygons, updatedlegends, updatedSlider, updatedselectedType;

	if (previousSelectedPolygonType !== selectedPolygonType) {
		// Accumulate all polygons (as an array) from each geo for the selected type.
		const accumulatedPolygons = selectedGeo.reduce((acc, geo) => {
			const geoPolygons = polygons[selectedPolygonType]?.[geo];
			return geoPolygons ? acc.concat(Object.values(geoPolygons)) : acc;
		}, []);

		updatedpolygons = accumulatedPolygons;
		updatedSlider = sliders[selectedPolygonType]?.selectedGeo?.[0] || [];
		updatedlegends = legends[selectedPolygonType] || [];

		if (
			has(filterPolygon, selectedPolygonType) &&
			[
				sec_density,
				whiteSpace_density,
				DailyTrafficData,
				PopulationGrids,
				demographicPopulationDensity,
				social_media_behaviors
			].includes(selectedPolygonType)
		) {
			// Filter the polygons using the appropriate filter function
			let newPoly = filterPolygon[selectedPolygonType]({
				sliderValue: currentSliderValues,
				filter: currentSliderValues[selectedPolygonType] || defaultSliderValues[selectedPolygonType],
				polygons: updatedpolygons
			});
			updatedpolygons = newPoly;
		}

		// If there is overlap logic defined for this polygon type, apply it.
		if (overLapPolygons[selectedPolygonType]) {
			const { newPolygons, newLegends, newSlider } = overLapPolygons[selectedPolygonType]({
				polygons,
				updatedpolygons,
				selectedGeo,
				sliders,
				legends,
				updatedSlider,
				updatedlegends
			});
			updatedpolygons = newPolygons;
			updatedlegends = newLegends;
			updatedSlider = newSlider;
		}

		updatedselectedType = selectedPolygonType;
	} else {
		// For the unchanged type, accumulate the default polygons.
		const accumulatedPolygons = selectedGeo.reduce((acc, geo) => {
			const geoPolygon = polygons[defaultpolygons]?.[geo];
			if (geoPolygon) acc.push(geoPolygon);
			return acc;
		}, []);

		updatedpolygons = accumulatedPolygons;
		updatedlegends = legends[defaultpolygons] || [];
		updatedSlider = sliders[defaultpolygons]?.selectedGeo?.[0] || [];
		updatedselectedType = defaultpolygons;
	}

	return { updatedpolygons, updatedlegends, updatedselectedType, updatedSlider };
};

function Home() {
	const { selectedRoute } = useParams();

	const [
		{
			areasMapping,
			apiTracking,
			shopCounts,
			shopsStructure,
			tableData,
			dropdownData,
			selecteddropDown,
			dropdownDataCopy,
			dropdownMapping,
			keyNameMapping,
			modelVisible,
			tenant_markers,
			tenant_markers_1,
			legends,
			_polygons,
			_markers,
			raw_markers,
			raw_tenant_markers,
			raw_tenant_markers_1,
			selectedPolygons,
			allPolygons,
			center,
			selectedType,
			loadingsData,
			selectedData,
			CellSiteIds,
			all_raw_tenant_markers,
			sliderValue,
			allSliders,
			polygonModal,
			selectedPolygon,
			markerDetailVisible,
			selectedMarker,
			previousSelectedFilters,
			defaultSliderValues,
			demographicFilterKeys,
			SocialMediaBehaviorsKeys,
			selectedPolygonShopListVisible,
			censusFilterKey
		},
		dispatch
	] = useReducer(reducer, _initialState);
	const { isUploading } = useContext(UploadContext);
	const { tenant, isSuperAdmin, email } = useMemo(() => {
		const { tenant, isSuperAdmin, email } = pick(userServices.getCurrentUser(), [
			"tenant",
			"isSuperAdmin",
			"email"
		]);
		dispatch({
			type: "setObject",
			actions: {
				set: {
					tenant
				}
			}
		});
		return { tenant, isSuperAdmin, email };
	}, [dropdownData]);

	const handlePolygonClick = useCallback(
		({ _id, type }) => {
			if (
				[
					PopulationGrids,
					DailyTrafficData,
					motor_spots,
					digitalPersona,
					TargetedConsumer,
					demographicPopulationDensity,
					social_media_behaviors
				].includes(type)
			) {
				let selectedPolygon = _polygons && Object.entries(_polygons).find(([, value]) => value.id === _id);

				dispatch({
					type: "setObject",
					actions: {
						set: {
							selectedPolygon: selectedPolygon?.[1],
							polygonModal: true
						}
					}
				});
				return;
			}

			if (has(allPolygons, `${defaultpolygons}.${_id}`)) {
				const currentPolygonTypeIndex = dropdownMapping.indexOf(type);
				const currentSelectedTypeIndex = dropdownMapping.indexOf(selectedType);

				let selected = getSelectedPolygons(_polygons).map(({ id }) => id);
				if (type === selectedType || currentPolygonTypeIndex > currentSelectedTypeIndex) {
					if (!selected.includes(_id)) {
						handleSelection({
							value: [_id, ...selected],
							dropdownDataCopy: dropdownData,
							index: currentPolygonTypeIndex,
							allPolygons,
							dispatch
						});
					} else {
						pull(selected, _id);
						if (selected.length >= 1) {
							handleSelection({
								value: selected,
								dropdownDataCopy: dropdownData,
								index: currentPolygonTypeIndex,
								allPolygons,
								dispatch
							});
						}
					}
				} else {
					// if (_polygons.length > 1) {
					// 	handleSelection({
					// 		value: [_id],
					// 		dropdownDataCopy,
					// 		index: currentPolygonTypeIndex,
					// 		allPolygons,
					// 		dispatch
					// 	});
					// } else {

					let findNext = [];
					let value = selected;
					dropdownDataCopy[currentPolygonTypeIndex]
						.filter(({ _id }) => value.includes(_id))
						.forEach(({ sub_areas }) => (findNext = [...findNext, ...sub_areas]));

					handleOnlyPolygon({
						value: findNext,
						dropdownDataCopy,
						index: currentPolygonTypeIndex + 1,
						allPolygons,
						dispatch
					});
					// }
				}
			}
		},
		[allPolygons, dropdownDataCopy, _polygons, dropdownMapping, dropdownData, selectedType]
	);

	FetchInitialData({ dispatch, isSuperAdmin, tenant, selectedRoute });
	const currentSelectedTypeIndex = useMemo(
		() => dropdownMapping?.indexOf(selectedType),
		[dropdownMapping, selectedType]
	);
	const currentPolygonsSelectedType = useMemo(() => {
		const samplePolygon = sample(_polygons);
		if (!isEmpty(samplePolygon)) {
			const { type } = samplePolygon;
			return type;
		}
		return null;
	}, [_polygons]);
	const downloadReport = useCallback(
		async ({ Filters, onDownloadProgress, cancelToken, targetKeys, clientFlag, email, emailReport }) => {
			let { censusFilter, tenantFilter } = getClientandTenantFilter(Filters);

			censusFilter = modifyFilterObjectForQuery(censusFilter);

			let { selectedTypeIds, type, filterData } = getselectedTypeIds(
				selecteddropDown,
				currentSelectedTypeIndex,
				selectedPolygons,
				CellSiteIds,
				selectedType,
				sliderValue,
				previousSelectedFilters
			);

			let res;
			if (!clientFlag) {
				res = await Services.downloadReport({
					Filters: censusFilter,
					selectedTypeIds,
					onDownloadProgress,
					cancelToken,
					targetKeys,
					selectedType: type,
					filterData,
					sliderValue,
					email,
					emailReport
				});
			} else {
				res = await Services.downloadRTMClientReport({
					Filters: tenantFilter,
					selectedTypeIds,
					onDownloadProgress,
					cancelToken,
					selectedType: type,
					targetKeys,
					filterData,
					sliderValue,
					email,
					emailReport
				});
			}

			const url = window.URL.createObjectURL(new Blob([res.data]));
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", clientFlag ? "Client Shops.xlsx" : "Census Shops.xlsx");
			document.body.appendChild(link);
			link.click();
		},
		[
			previousSelectedFilters,
			sliderValue,
			selectedType,
			raw_markers,
			selecteddropDown,
			CellSiteIds,
			selectedPolygons,
			currentSelectedTypeIndex
		]
	);

	const getRoutesData = useCallback(() => {
		if (!allPolygons["ShowStatsData"]) {
			Info("Loading Routes Data... Try Again Later.");
			return null;
		} else {
			if (selecteddropDown?.[currentSelectedTypeIndex]) {
				let excelData = [];
				for (const geo of selecteddropDown[currentSelectedTypeIndex]) {
					if (has(allPolygons, `ShowStatsData.${geo}`)) {
						const data = allPolygons["ShowStatsData"][geo];
						if (data) {
							let row = { Name: keyNameMapping[geo] };
							for (let [key, value] of Object.entries(data)) {
								if (Array.isArray(value)) {
									row[key] = value.length;
								} else if (typeof value === "number" || typeof value === "string") {
									row[key] = value;
								} else if (typeof value === "object") {
									let sec = {};
									for (let [k1, v1] of Object.entries(value)) {
										sec[`Sec-${k1}`] = v1 ? (v1 * 100).toFixed(2) : v1;
									}
									row = { ...row, ...sec };
								}
							}
							excelData.push(row);
						}
					}
				}

				return excelData;
			} else {
				return null;
			}
		}
	}, [allPolygons, selecteddropDown, currentSelectedTypeIndex, keyNameMapping]);

	const pushCensusShops = useCallback(
		async Filters => {
			Filters = modifyFilterObjectForQuery(Filters);
			let { selectedTypeIds, type, filterData } = getselectedTypeIds(
				selecteddropDown,
				currentSelectedTypeIndex,
				selectedPolygons,
				CellSiteIds,
				selectedType,
				sliderValue,
				previousSelectedFilters
			);

			function pushShopsToValidationApp(selectedTypeIds, Filters, type, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.pushCensusShops({ selectedTypeIds, Filters, selectedType: type, filterData })
							.then(({ data }) => {
								const modifiedCount = data?.modifiedCount || 0;
								notification.success({
									message: "Success",
									description: `${modifiedCount} Shops Pushed to Validation App`
								});
							})
							.catch(error => {
								notification.error({
									message: "Error",
									description: error.message || "Error While Pushing Shops to Validation App"
								});
								reject(error);
							})
					);
				});
			}

			const shopIdsPromise = await pushShopsToValidationApp(selectedTypeIds, Filters, type, filterData);

			return [shopIdsPromise];
		},
		[
			previousSelectedFilters,
			sliderValue,
			selectedType,
			raw_markers,
			selecteddropDown,
			CellSiteIds,
			selectedPolygons,
			currentSelectedTypeIndex
		]
	);

	const pullCensusShops = useCallback(
		async Filters => {
			Filters = modifyFilterObjectForQuery(Filters);
			let { selectedTypeIds, type, filterData } = getselectedTypeIds(
				selecteddropDown,
				currentSelectedTypeIndex,
				selectedPolygons,
				CellSiteIds,
				selectedType,
				sliderValue,
				previousSelectedFilters
			);

			function pushShopsToValidationApp(selectedTypeIds, Filters, type, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.pullCensusShops({ selectedTypeIds, Filters, selectedType: type, filterData })
							.then(({ data }) => {
								const modifiedCount = data?.modifiedCount || 0;

								notification.success({
									message: "Success",
									description: `${modifiedCount} Shops Pulled From Validation App`
								});
							})
							.catch(error => {
								notification.error({
									message: "Error",
									description: error.message || "Error While Pull Shops From Validation App"
								});
								reject(error);
							})
					);
				});
			}

			const shopIdsPromise = await pushShopsToValidationApp(selectedTypeIds, Filters, type, filterData);

			return [shopIdsPromise];
		},
		[
			previousSelectedFilters,
			sliderValue,
			selectedType,
			raw_markers,
			selecteddropDown,
			CellSiteIds,
			selectedPolygons,
			currentSelectedTypeIndex
		]
	);
	const FilterCescusShops = useCallback(
		Filters => {
			Filters = modifyFilterObjectForQuery(Filters);
			let { selectedTypeIds, type, filterData } = getselectedTypeIds(
				selecteddropDown,
				currentSelectedTypeIndex,
				selectedPolygons,
				CellSiteIds,
				selectedType,
				sliderValue,
				previousSelectedFilters
			);

			function createShopIdsPromise(selectedTypeIds, Filters, type, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.getFilteredShopIds({
							selectedTypeIds,
							Filters,
							selectedType: type,
							filterData,
							sliderValue
						})
							.then(({ data }) => {
								let FilteredMarkers = pick(raw_markers, data);
								return {
									_markers: FilteredMarkers
								};
							})
							.catch(error => reject(error))
					);
				});
			}

			function createShopCountPromise(Filters, selectedTypeIds, type, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.applyFilter({ Filters, selectedTypeIds, selectedType: type, filterData, sliderValue })
							.then(({ data }) => {
								return {
									[`tableData.${filteredShops}`]: data
								};
							})
							.catch(error => reject(error))
					);
				});
			}
			const isCencusMarkerLoaded = getBooleanVale(selectedData, `Markers.${selectedType}`, false);

			let shopIdsPromise = null;

			if (isCencusMarkerLoaded) {
				shopIdsPromise = createShopIdsPromise(selectedTypeIds, Filters, type, filterData);
			}
			const shopCountPromise = createShopCountPromise(Filters, selectedTypeIds, type, filterData);

			return [shopIdsPromise, shopCountPromise];
		},
		[
			previousSelectedFilters,
			sliderValue,
			selectedType,
			raw_markers,
			selecteddropDown,
			CellSiteIds,
			selectedPolygons,
			currentSelectedTypeIndex,
			selectedData
		]
	);
	const FilterClientShops = useCallback(
		(Filters, filterKey) => {
			Filters = modifyFilterObjectForQuery(Filters);
			let Key = filterKey || `${getTenantName(tenant)} Selected`;
			if (has(defaultFilters, `${tenant}-${filterKey}`)) {
				Filters = {
					...Filters,
					...defaultFilters[`${tenant}-${filterKey}`]
				};
			}
			let { selectedTypeIds, type, filterData } = getselectedTypeIds(
				selecteddropDown,
				currentSelectedTypeIndex,
				selectedPolygons,
				CellSiteIds,
				selectedType,
				sliderValue,
				previousSelectedFilters
			);

			if ([demographicPopulationDensity, social_media_behaviors].includes(selectedPolygons)) {
				const filters = JSON.parse(localStorage.getItem("userFilters"));
				const shopperProfileFilter =
					selectedPolygons === demographicPopulationDensity
						? cloneDeep(filters["shopper_profile"])
						: cloneDeep(filters["digital_persona"]);

				Filters.shopper_profile = shopperProfileFilter;
			}
			function createClientFilterPromise(Filters, selectedTypeIds, type, Key, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.applyClientFilter({
							Filters,
							selectedTypeIds,
							selectedType: type,
							filterData,
							sliderValue
						})
							.then(({ data }) => {
								return {
									[`tableData.${Key}`]: data
								};
							})
							.catch(error => reject(error))
					);
				});
			}
			function createClientFilterIdsPromise(Filters, selectedTypeIds, type, filterData) {
				return new Promise((resolve, reject) => {
					resolve(
						Services.getClientFilterIds({
							Filters,
							selectedTypeIds,
							selectedType: type,
							filterData,
							sliderValue
						})
							.then(({ data }) => {
								if (has(defaultFilters, `${tenant}-${filterKey}`)) {
									let tenant_markers_1 = pick(raw_tenant_markers_1, data);
									return { tenant_markers_1 };
								}
								let tenant_markers = pick(raw_tenant_markers, data);

								return { tenant_markers };
							})
							.catch(error => reject(error))
					);
				});
			}

			const isTenantShopsLoaded = getBooleanVale(
				selectedData,
				`${filterKey ? "ClientMarkers1" : "ClientMarkers"}.${selectedType}`,
				false
			);

			const clientFilterContPromise = createClientFilterPromise(Filters, selectedTypeIds, type, Key, filterData);
			let clientFilterIdsPromise = null;

			if (isTenantShopsLoaded) {
				clientFilterIdsPromise = createClientFilterIdsPromise(Filters, selectedTypeIds, type, filterData);
			}

			return [clientFilterContPromise, clientFilterIdsPromise];
		},
		[
			previousSelectedFilters,
			sliderValue,
			selectedType,
			raw_tenant_markers,
			tenant,
			selecteddropDown,
			currentSelectedTypeIndex,
			CellSiteIds,
			selectedPolygons,
			selectedData
		]
	);
	const FilterShops = useCallback(
		async (Filters, selectedPolygons, tenant) => {
			let Key = `${getTenantName(tenant)} Selected`;
			if (isEmpty(_polygons)) {
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`tableData.${Key}`]: 0,
							[`tableData.${filteredShops}`]: 0,
							["_markers"]: {},
							["tenant_markers"]: {},
							["tenant_markers_1"]: {}
						}
					}
				});
				return;
			}

			// if (Array.isArray(_polygons)) {
			// 	// If _polygons is an array and not empty, exit early.
			// 	if (_polygons.length > 0) {
			// 		return;
			// 	}
			// } else if (typeof _polygons === "object" && _polygons !== null) {
			// 	// If _polygons is an object (not null) and has at least one key, exit early.
			// 	if (Object.keys(_polygons).length > 0) {
			// 		return;
			// 	}
			// }
			// else if()
			const { censusFilter, tenantFilter } = getClientandTenantFilter(Filters);
			const [shopIdsPromise, shopCountPromise] = FilterCescusShops(censusFilter);
			let countPromises = [shopCountPromise];
			const isCencusMarkerLoaded = getBooleanVale(selectedData, `Markers.${selectedType}`, false);

			let idsPromises = [];

			if (isCencusMarkerLoaded) {
				idsPromises = [shopIdsPromise];
			}

			let setLoadings = {
				[`tableData.${filteredShops}`]: "LOADING",
				[`tableData.${bat_contracted_outlets_selected}`]: "LOADING"
			};

			const isTenantShopsLoaded = getBooleanVale(selectedData, `ClientMarkers.${selectedType}`, false);

			// if (checkClientFilter(tenantFilter, selectedPolygons, tenant)) {
			setLoadings = { ...setLoadings, [`tableData.${Key}`]: "LOADING" };
			const [clientFilterContPromise, clientFilterIdsPromise] = FilterClientShops(tenantFilter);

			countPromises = [...countPromises];

			if (isTenantShopsLoaded) {
				idsPromises = [...idsPromises, clientFilterIdsPromise];
			}
			// }
			if (havePermission(MARKER_PERMISSIONS.TABLE_CLINET_1_SHOPS_COUNT)) {
				const [batContractedFilterContPromise, batContractedFilterIdsPromise] = FilterClientShops(
					tenantFilter,
					bat_contracted_outlets_selected
				);

				countPromises = [...countPromises, batContractedFilterContPromise];

				const ifBatContractedFilterShopsLoaded = getBooleanVale(
					selectedData,
					`ClientMarkers1.${selectedType}`,
					false
				);

				if (ifBatContractedFilterShopsLoaded) {
					idsPromises = [...idsPromises, batContractedFilterIdsPromise];
				}
			}

			dispatch({
				type: "setObject",
				actions: {
					set: setLoadings
				}
			});

			const clientCountResult = await Promise.allSettled([clientFilterContPromise]).then(results => {
				const rejectedPromises = results.filter(result => result.status === "rejected");
				if (rejectedPromises.length > 0) {
					return Promise.reject(rejectedPromises.map(({ reason }) => reason));
				} else {
					// Return the result if all promises are resolved
					return Promise.resolve(results.map(({ value }) => value));
				}
			});

			if (clientCountResult.every(key => key !== undefined)) {
				let dataForState = {};

				clientCountResult.forEach(data => {
					dataForState = { ...dataForState, ...data };
				});
				dispatch({
					type: "setObject",
					actions: {
						set: dataForState
					}
				});
			} else {
				Error("Error While Appling Filter");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`tableData.${Key}`]: "ERR",
							[`tableData.${filteredShops}`]: "ERR"
						}
					}
				});
			}

			Promise.allSettled(idsPromises)
				.then(results => {
					const rejectedPromises = results.filter(result => result.status === "rejected");

					if (rejectedPromises.length > 0) {
						// If there are rejected promises, reject the entire Promise chain with the reasons
						return Promise.reject(rejectedPromises.map(({ reason }) => reason));
					} else {
						// If all promises are settled, proceed with processing the resolved values
						const dataForState = results.reduce((acc, { value }) => ({ ...acc, ...value }), {});
						// Assuming 'dispatch' is a function that dispatches an action
						dispatch({
							type: "setObject",
							actions: {
								set: dataForState
							}
						});

						// Returning the resolved data for further use (optional)
						return dataForState;
					}
				})
				.catch(errors => {
					// Handle any errors from rejected promises
					console.error("Error processing promises:", errors);
				});

			const result = await Promise.allSettled(countPromises).then(results => {
				const rejectedPromises = results.filter(result => result.status === "rejected");
				if (rejectedPromises.length > 0) {
					return Promise.reject(rejectedPromises.map(({ reason }) => reason));
				} else {
					// Return the result if all promises are resolved
					return Promise.resolve(results.map(({ value }) => value));
				}
			});

			if (result.every(key => key !== undefined)) {
				let dataForState = {};

				result.forEach(data => {
					dataForState = { ...dataForState, ...data };
				});
				dispatch({
					type: "setObject",
					actions: {
						set: dataForState
					}
				});
				return true;
			} else {
				Error("Error While Appling Filter");
				dispatch({
					type: "setObject",
					actions: {
						set: {
							[`tableData.${Key}`]: "ERR",
							[`tableData.${filteredShops}`]: "ERR"
						}
					}
				});
				return false;
			}
		},
		[FilterCescusShops, FilterClientShops, _polygons, selectedData, selectedType]
	);

	const isBATADMIN = useMemo(() => {
		return localStorage.getItem("role") === "BAT_ADMIN";
	}, []);

	return (
		<ReactContainer
			fluid
			className="px-0"
			style={{
				margin: "10px",
				width: "calc(100% - 20px)", // 100 % – left+right margin
				overflow: "hidden"
			}}
		>
			<MainNavbar />
			{isUploading && <Modals title={"Import"} steps={<OutletsSteps />} />}
			{getBooleanVale(apiTracking, tenant, true) ? (
				<Initial apiTracking={apiTracking} tenant={tenant} />
			) : (
				<HomeContext.Provider
					value={{
						tenant,
						loadingsData,
						selectedPolygons,
						downloadReport,
						FilterShops,
						dispatch,
						sliderValue,
						pushCensusShops,
						pullCensusShops,
						censusFilterKey
					}}
				>
					<>
						<ReactRow className="r1 pl-3">
							{isBATADMIN && (
								<ReactRow className="r1 pl-3">
									<h4
										style={{
											marginTop: "10px"
										}}
									>
										Switch Users
									</h4>
									<Select
										value={email}
										style={{ width: "200px", marginLeft: "10px", marginTop: "10px" }}
										onChange={async value => {
											const passwords = {
												"bat_uk_independent@gmail.com": "caZ@Lct4",
												"admin_bat_organized@gmail.com": "Arc@Pg3r7"
											};

											await userServices.login({
												email: value,
												password: passwords[value]
											});
											dispatch({
												type: "resetAll"
											});
											localStorage.setItem("role", "BAT_ADMIN");
										}}
										options={[
											{ label: "Independent", value: "bat_uk_independent@gmail.com" },
											{
												label: "Organized",
												value: "admin_bat_organized@gmail.com"
											}
										]}
									></Select>
								</ReactRow>
							)}
							<ReactCol lg={12} md={12} sm={12} className="r1">
								<div className="d-flex mt-3 row">
									{dropdownData.map((data, index) => {
										const Label = ` ${dropdownMapping[index]}`;
										let disable = currentSelectedTypeIndex < index;
										// if (!disable) disable = index > selecteddropDown.length;

										return (
											<div className="d-flex col-lg-3 col-md-6 col-sm-12 pl-0">
												<div>
													<h6 className="mr-2 pt-2">{formateString(Label)}</h6>
												</div>
												<div className="w-100">
													<Select
														filterOption={(inputValue, { label }) => {
															return label
																.toUpperCase()
																.includes(inputValue.toUpperCase());
														}}
														disabled={disable}
														value={selecteddropDown[index] || []}
														placeholder={`Select ${formateString(Label)}`}
														maxTagCount="responsive"
														mode="multiple"
														key={`DropDown-${index}-${Label}`}
														style={{ width: "100%" }}
														onChange={value => {
															if (value.length > 1 && tenant === "BAT_STATES") {
																value = [value[value.length - 1]];
															}
															console.log("value", value);

															if (value.includes("Select/Un-Select All")) {
																value = selectUnselectAll(
																	value,
																	dropdownData[index].map(({ _id }) => _id)
																);
															}

															if (value.length > 0)
																handleSelection({
																	dispatch,
																	value,
																	dropdownDataCopy: dropdownData,
																	index,
																	allPolygons
																});
														}}
														options={[
															...(tenant !== "BAT_STATES"
																? [
																		{
																			label: "Select/Un-Select All",
																			key: "Select/Un-Select All",
																			value: "Select/Un-Select All"
																		}
																  ]
																: []),
															...data.map(({ _id, name }) => {
																return {
																	label: `${name}`,
																	key: _id,
																	value: _id
																};
															})
														]}
													/>
												</div>
											</div>
										);
									})}
								</div>
							</ReactCol>
						</ReactRow>
						<ReactRow className="r2 pl-3">
							<ReactCol lg={12} md={12} sm={12} className="pl-0">
								<div className="mt-3">
									<Radio.Group
										className="custom-radio-button"
										onChange={({ target: { value } }) => {
											dispatch({
												type: "setObject",
												actions: {
													set: {
														selectedType: value
													}
												}
											});
											dispatch({
												type: "UPDATETABLEDATA"
											});
										}}
										value={selectedType}
									>
										{dropdownMapping.map(type => {
											return <Radio value={type}>{formateString(type)}</Radio>;
										})}
									</Radio.Group>

									<Button
										className="reset-btn ml-4"
										style={{ width: "70px" }}
										onClick={() => {
											let selected = [];
											dropdownDataCopy[0].forEach(({ _id }) => selected.push(_id));
											handleSelection({
												value: selected,
												dropdownDataCopy,
												index: 0,
												allPolygons,
												dispatch
											});
										}}
									>
										Reset
									</Button>
								</div>
							</ReactCol>
						</ReactRow>
						<ReactRow className="r3">
							<ReactCol lg={8} md={8} sm={12}>
								<DownloadMarkersButtonLayer
									tenant={tenant}
									selecteddropDown={selecteddropDown}
									currentSelectedTypeIndex={currentSelectedTypeIndex}
									shopCounts={shopCounts}
									keyNameMapping={keyNameMapping}
									shopsStructure={shopsStructure}
									apiTracking={apiTracking}
									dispatch={dispatch}
									areasMapping={areasMapping}
									selectedType={selectedType}
									currentPolygonsSelectedType={currentPolygonsSelectedType}
								/>

								{allClientMarkersVisibility[tenant] && (
									<DownloadShops
										dispatch={dispatch}
										apiTracking={apiTracking}
										buttonLabel={"Download All Client Shops"}
										key={"ALLCLIENTSHOPS"}
										title={"Download Client Shops"}
									/>
								)}
							</ReactCol>

							<ReactCol lg={4} md={4} sm={12}>
								<Row justify={"end"}>
									<Button
										style={{
											marginRight: "1rem"
										}}
										disabled={
											![
												PopulationGrids,
												DailyTrafficData,
												motor_spots,
												sec_density,
												whiteSpace_density,
												demographicPopulationDensity,
												social_media_behaviors
											].includes(currentPolygonsSelectedType)
										}
										className="unselect-all-areas-btn"
										onClick={async () => {
											await dispatch({
												type: "RESETALLSLIDERS"
											});
											dispatch({
												type: swtichPolygons,
												polygons: currentPolygonsSelectedType
											});
										}}
									>
										Reset All Sliders
									</Button>
									<Button
										className="unselect-all-areas-btn"
										onClick={() => {
											let originalValue = dropdownData[currentSelectedTypeIndex].map(
												({ _id }) => _id
											);
											originalValue = ["Select/Un-Select All", ...originalValue];
											const value = selectUnselectAll(
												originalValue,
												dropdownData[currentSelectedTypeIndex].map(({ _id }) => _id)
											);
											handleSelection({
												value,
												dropdownDataCopy: dropdownData,
												index: currentSelectedTypeIndex,
												allPolygons,
												dispatch
											});
										}}
									>
										Unselect all Areas
									</Button>{" "}
								</Row>
							</ReactCol>
						</ReactRow>
						<ReactRow>
							<ReactCol lg={12} md={12} sm={12} className="mt-0">
								<div className="r4  cx">
									{selecteddropDown?.[currentSelectedTypeIndex]?.[0] &&
										selecteddropDown[currentSelectedTypeIndex].length === 1 && (
											<PolygonLayers
												defaultFilterValues={defaultSliderValues}
												filters={sliderValue}
												dispatch={dispatch}
												tenant={tenant}
												selectedPolygons={selectedPolygons}
												loadingsData={loadingsData}
												geo={selecteddropDown[currentSelectedTypeIndex][0]}
											/>
										)}
								</div>
							</ReactCol>
						</ReactRow>

						<ReactRow className="r4 mt-2 h-100">
							<>
								<ReactCol lg={8} md={12} sm={12} className="mb-3 mb-lg-0">
									<ReactCard className="shadow ">
										{/* Existing top overlay */}
										<div
											style={{
												position: "absolute",
												display: "flex",
												width: "100%",
												left: "0%",
												zIndex: 3,
												backgroundColor: "#00000085"
											}}
										>
											<div className="w-100">
												<Legends
													geo={selecteddropDown?.[currentSelectedTypeIndex]?.[0]}
													demographicFilterKeys={demographicFilterKeys}
													SocialMediaBehaviorsKeys={SocialMediaBehaviorsKeys}
													legend={[...legends]}
													allSliders={allSliders}
													sliderValue={sliderValue}
													selectedPolygonType={selectedPolygons}
												/>
											</div>
										</div>

										{/* Map container */}
										<div style={{ position: "relative" }}>
											{/* Second overlay, offset from top so it doesn't overlap */}

											{[sec_density, SecPolgons].includes(selectedPolygons) && (
												<TenantSecDefinition />
											)}
											{/* Your map component */}
											<GoogleMap
												// key={`${selectedType}`}
												// zoomToPolygon
												buildHeatMap={[populationDensity].includes(selectedPolygons)}
												polygons={_polygons}
												handlePolygonClick={({ _id, type, polygonData }) => {
													if (type === smoking_zones) {
														dispatch({
															type: "setObject",
															actions: {
																set: {
																	selectedPolygon: polygonData,
																	selectedPolygonShopListVisible: true
																}
															}
														});
														return;
													}
													handlePolygonClick({
														_id,
														type
													});
												}}
												handleMarkerClick={marker => {
													dispatch({
														type: "setObject",
														actions: {
															set: {
																selectedMarker: marker,
																markerDetailVisible: true
															}
														}
													});
												}}
												tenant={tenant}
												center={center}
												markers={{
													census_Shops: getBooleanVale(
														selectedData,
														`Markers.${selectedType}`,
														false
													),
													tenant_Shops: getBooleanVale(
														selectedData,
														`ClientMarkers.${selectedType}`,
														false
													),
													all_tenant_markers: getBooleanVale(
														selectedData,
														`AllClientMarkers.${selectedType}`,
														false
													),
													tenant_Shops_1: getBooleanVale(
														selectedData,
														`ClientMarkers1.${selectedType}`,
														false
													),
													total:
														Object.keys(tenant_markers).length +
														Object.keys(tenant_markers_1).length +
														Object.keys(_markers).length +
														Object.keys(all_raw_tenant_markers).length
												}}
												tenant_markers={tenant_markers}
												tenant_markers_1={tenant_markers_1}
												_markers={_markers}
												all_raw_tenant_markers={all_raw_tenant_markers}
											/>
										</div>

										<div
											className={"md-2"}
											style={{
												position: "absolute",
												bottom: "5px",
												left: "20px",
												width: "100%"
											}}
										>
											<PolygonModal
												polygonType={selectedPolygons}
												polygon={selectedPolygon}
												isVisible={polygonModal}
												onClose={() => {
													dispatch({
														type: "setObject",
														actions: {
															set: {
																polygonModal: false
															}
														}
													});
												}}
											/>
											<MapButtons
												tenant={tenant}
												dispatch={dispatch}
												selectedData={selectedData}
												selectedType={selectedType}
												selecteddropDown={selecteddropDown}
												currentSelectedTypeIndex={currentSelectedTypeIndex}
												markersOnMap={Object.keys(_markers).length}
												clientMarkersOnMap={Object.keys(tenant_markers).length}
												all_raw_tenant_markers={Object.keys(all_raw_tenant_markers).length}
												tenant_markers_1={Object.keys(tenant_markers_1).length}
												shopCounts={shopCounts}
												shopsStructure={shopsStructure}
											/>
										</div>

										{/* </Fragment> */}
									</ReactCard>
								</ReactCol>
								<ReactCol lg={4} md={12} sm={12} className=" mob-view-filter  pl-lg-0">
									<ReactCard className="h-100P shadow">
										<div
											className="scroll-area-lg1 scrollableListingsX   sec-wise"
											style={{ overflowY: "auto", height: mapHeight }}
										>
											<Filters
												loadingsData={loadingsData}
												_tenant={tenant}
												homeDispatch={dispatch}
											>
												{[
													getCountTable({
														loadingsData,
														selectedType,

														tenant,
														tableData
													}),
													<DownloadRouteData
														disable={currentPolygonsSelectedType !== selectedType}
														getRoutesData={getRoutesData}
													/>
												]}
											</Filters>
										</div>
									</ReactCard>
								</ReactCol>
							</>
							{/* // )} */}
						</ReactRow>
						{modelVisible && (
							<Stats
								selecteddropDown={selecteddropDown}
								tableData={tableData}
								tenant={tenant}
								modelVisible={modelVisible}
								dispatch={dispatch}
								tenant_markers={Object.values(tenant_markers)}
								_markers={Object.values(_markers)}
							/>
						)}
					</>
					{markerDetailVisible && (
						<HandleMarkerClick
							key={selectedMarker?.id}
							visible={markerDetailVisible}
							selectedMarker={selectedMarker}
							setVisible={value => {
								dispatch({
									type: "setObject",
									actions: {
										set: {
											markerDetailVisible: value
										}
									}
								});
							}}
						/>
					)}
					{selectedPolygonShopListVisible && (
						<SelectedPolygonShopList
							HandleMarkerClick={selectedMarker => {
								dispatch({
									type: "setObject",
									actions: {
										set: {
											selectedMarker,
											markerDetailVisible: true
										}
									}
								});
							}}
							selectedPolygon={selectedPolygon}
							isVisible={selectedPolygonShopListVisible}
							setIsVisible={() => {
								dispatch({
									type: "setObject",
									actions: {
										set: {
											selectedPolygonShopListVisible: false
										}
									}
								});
							}}
						/>
					)}
				</HomeContext.Provider>
			)}
		</ReactContainer>
	);
}

export default Home;

const handleOnlyPolygon = ({ value, dropdownDataCopy, index, allPolygons, dispatch }) => {
	let new_polygons = [];
	// let dataTest = dropdownDataCopy[index];

	// dataTest.filter(({ _id }) => value.includes(_id)).forEach(({ sub_areas }) => (findNext = [...findNext, ...sub_areas]));
	// const nextValue = flattenDeep(Object.values(dropdownDataCopy)).filter(({ _id }) => findNext.includes(_id));

	const allIds = dropdownDataCopy[index].filter(({ _id }) => value.includes(_id)).map(({ _id }) => _id);
	allIds.forEach(_id => {
		if (has(allPolygons, `${defaultpolygons}.${_id}`)) {
			if (value.includes(_id)) {
				new_polygons.push(allPolygons[defaultpolygons][_id]);
			} else {
				let polygon = cloneDeep(allPolygons[defaultpolygons][_id]);
				set(polygon, "style.fillColor", "#808080");
				new_polygons.push(polygon);
				// tranparentPolygons.push();
			}
		}
	});
	let { polygon, legends } = modifyPolygons({
		new_polygons,
		allPolygons,
		dispatch,
		index
	});
	new_polygons = polygon;
	const center = FindCenter(Object.values(new_polygons).map(({ center }) => center));

	dispatch({
		type: "setObject",
		actions: {
			set: {
				center,
				_polygons: new_polygons,
				legends: legends,
				// dropdownData:dropdownDataCopy,
				slider: null
			}
		}
	});

	let findNext = [];

	let data = dropdownDataCopy[index];

	data.filter(({ _id }) => value.includes(_id)).forEach(({ sub_areas }) => (findNext = [...findNext, ...sub_areas]));

	const nextValue = flattenDeep(Object.values(dropdownDataCopy)).filter(({ _id }) => findNext.includes(_id));

	if (nextValue.length > 0)
		dispatch({
			type: "SetArray",
			value: {
				index: index + 1,
				value: nextValue || [],
				key: "dropdownData"
			}
		});
	if (index < dropdownDataCopy.length) {
		dispatch({
			type: "SetArray",
			value: {
				index: index,
				key: "selecteddropDown",
				value: value || []
			}
		});
		// dispatch({
		// 	type: "SetArray",
		// 	value: {
		// 		index: index,
		// 		key: "dropdownData",
		// 		value: dropdownDataCopy[index] || []
		// 	}
		// });
		dispatch({
			type: "UPDATETABLEDATA"
		});
	}
};

const modifyPolygons = ({ new_polygons, allPolygons, dispatch, index }) => {
	let { type } = sample(new_polygons);
	let legends = [];
	if (type === "CENSUS_BLOCK") {
		let data = allPolygons?.["ShowStatsData"];
		legends = [
			getLegend({
				text: `Completed`,
				color: "#00FF00",
				onClick: () => {
					let polygons = new_polygons.filter(polygon => {
						const { id } = polygon;
						const polygonData = data[id];
						if (polygonData) {
							const { is_completed } = polygonData;
							return is_completed;
						}

						return polygon;
					});
					dispatch({
						type: "setObject",
						actions: {
							set: {
								_polygons: polygons
							}
						}
					});
					dispatch({
						type: "SetArray",
						value: {
							index,
							key: "selecteddropDown",
							value: polygons.map(({ id }) => id) || []
						}
					});
					dispatch({
						type: "UPDATETABLEDATA"
					});
				}
			}),
			getLegend({
				text: `Not-Completed`,
				color: "#FF0000",
				onClick: () => {
					let polygons = new_polygons.filter(polygon => {
						const { id } = polygon;
						const polygonData = data[id];
						if (polygonData) {
							const { is_completed } = polygonData;
							return !is_completed;
						}

						return polygon;
					});
					dispatch({
						type: "setObject",
						actions: {
							set: {
								_polygons: polygons
							}
						}
					});
					dispatch({
						type: "SetArray",
						value: {
							index,
							key: "selecteddropDown",
							value: polygons.map(({ id }) => id) || []
						}
					});
					dispatch({
						type: "UPDATETABLEDATA"
					});
				}
			})
			// getLegend({
			// 	text: `Both`,
			// 	color: "#FFFFFF",
			// 	onClick: () => {
			// 		dispatch({ type: filterPolygons, value: { value: undefined, type: "CENSUS_BLOCK" } });
			// 	}
			// })
		];
		if (data) {
			new_polygons = new_polygons.map(polygon => {
				const { id } = polygon;
				const polygonData = data[id];
				if (polygonData) {
					const { is_completed } = polygonData;
					return is_completed
						? {
								...polygon,
								filterData: { value: is_completed },
								style: {
									fillColor: "#00FF00",
									strokeColor: "#000000"
								}
						  }
						: {
								...polygon,
								filterData: { value: is_completed },
								style: {
									fillColor: "#FF0000",
									strokeColor: "#000000"
								}
						  };
				}

				return polygon;
			});
		}
	}

	return { polygon: new_polygons, legends };
};
const handleSelection = ({ value, dropdownDataCopy, index, allPolygons, dispatch }) => {
	let new_polygons = [];

	const allIds = dropdownDataCopy[index].map(({ _id }) => _id);
	allIds.forEach(_id => {
		if (has(allPolygons, `${defaultpolygons}.${_id}`)) {
			if (value.includes(_id)) {
				new_polygons.push(allPolygons[defaultpolygons][_id]);
			} else {
				let polygon = cloneDeep(allPolygons[defaultpolygons][_id]);
				set(polygon, "style.fillColor", "#808080");
				new_polygons.push(polygon);
				// tranparentPolygons.push();
			}
		}
	});

	let { polygon, legends } = modifyPolygons({
		new_polygons,
		allPolygons,
		dispatch,
		index
	});
	new_polygons = polygon;
	const center = FindCenter(Object.values(new_polygons).map(({ center }) => center));

	dispatch({
		type: "setObject",
		actions: {
			set: {
				center,
				_polygons: new_polygons,
				legends: legends,
				slider: null,
				selectedPolygons: defaultpolygons
			}
		}
	});

	let findNext = [];

	let data = dropdownDataCopy[index];

	if (dropdownHierarchyType()) {
		data.forEach(({ sub_areas = [] }) => (findNext = [...findNext, ...sub_areas]));
	} else {
		data.filter(({ _id }) => value.includes(_id)).forEach(
			({ sub_areas }) => (findNext = [...findNext, ...sub_areas])
		);
	}

	const nextValue = findNext.map(_id => allPolygons[defaultpolygons][_id]);

	if (dropdownHierarchyType()) {
		// unique parent_areas
		let parent_areas = data
			.filter(({ _id }) => {
				return value.includes(_id);
			})
			.map(({ parent_area }) => {
				return parent_area;
			});

		parent_areas = Array.from(new Set(parent_areas));

		dispatch({
			type: "SetArray",
			value: {
				index: index - 1,
				key: "selecteddropDown",
				value: parent_areas || []
			}
		});
	} else {
		if (nextValue.length > 0)
			dispatch({
				type: "SetArray",
				value: {
					index: index + 1,
					value: nextValue || [],
					key: "dropdownData"
				}
			});
	}

	// const nextValue = flattenDeep(Object.values(dropdownDataCopy)).filter(({ _id }) => findNext.includes(_id));

	dispatch({
		type: "SetArray",
		value: {
			index,
			key: "selecteddropDown",
			value: value || []
		}
	});

	dispatch({
		type: "UPDATETABLEDATA"
	});
};

function selectUnselectAll(value, originalValues) {
	value.splice(value.indexOf("Select/Un-Select All"), 1);
	if (value.length === originalValues.length) {
		value = [originalValues[0]];
	} else {
		value = originalValues;
	}

	return value;
}
function FetchInitialData({ dispatch, tenant, selectedRoute }) {
	useEffect(() => {
		getUserPolygons({ dispatch, handleSelection, tenant, selectedRoute });
	}, [Services, tenant]);
}
